import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

import { Event } from "../_types"

const getPath = (id: number) => `/events/${id}`

type GetEventsById = Event

export const fetchGetEventsById = defineFetcher((id: number): Promise<GetEventsById> => {
  return GET(getPath(id))
})
